"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flipBitMatrix = void 0;
var utils_1 = require("../../../utils");
var flipBitMatrix = function (target) {
    return target.update('data', function (data) { return (0, utils_1.flipReadonlyBitArray)(data); });
};
exports.flipBitMatrix = flipBitMatrix;
